import CheckboxCell from "../../../common/interactive/CheckboxCell";

export default function ExportWorkQGroupItem({item, actionModifier, groupName}) {
    function changeHandler(value) {
        if (actionModifier) {
            actionModifier(groupName, item.key, value.data.value)
        }
    }
    return <>
        <CheckboxCell checked={item.selected} label={item.name} direction={'reverse'} action={changeHandler}/>
    </>
}